import React from "react";
import Tab from "src/app/components/Tabs/Tab";
import Tabs from "src/app/components/Tabs/Tabs";
import { camelCaseToTitleCase } from "src/utils/methods";

import "./InsightsDashboardTabs.scss";

interface Props {
  breakdownOptions: string[];
  selectedBreakdown: string;
  setSelectedBreakdown: (value: string) => void;
}

export const InsightsDashboardTabs = (props: Props) => {
  const { breakdownOptions, selectedBreakdown, setSelectedBreakdown } = props;

  return (
    <Tabs className="insights-dashboard-tabs">
      {breakdownOptions.map((option) => (
        <Tab
          key={option}
          tabText={camelCaseToTitleCase(option)}
          active={selectedBreakdown === option}
          onClick={() => setSelectedBreakdown(option)}
        />
      ))}
    </Tabs>
  );
};
